import type { ImageChooserBlock } from "@reactivated";

type Options = {
    alt: string;
    width: number;
    height: number;
    mimetype: string;
};

/**
 * Make static assets compatible with ImageChooserBlock
 */
export const buildLocalImage = (
    url: string,
    options: Options,
): ImageChooserBlock => ({
    title: options.alt,
    description: "",
    default_alt_text: options.alt,
    width: options.width,
    height: options.height,
    brightness: null,
    url,
    renditions: {
        original: {
            spec: "original",
            width: options.width,
            height: options.height,
            url,
            size: 0,
            mimetype: options.mimetype,
        },
    },
    imageData: null,
});
